import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimHtmlcontent'
})
export class TrimHtmlcontentPipe implements PipeTransform {

  transform(html: string): any {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (doc.body.innerHTML.length < 200){
      return doc.body.innerHTML
    }
    else{
      return doc.body.textContent?.slice(0, 200);  
    }
  }
}
